export class TracingAccountIsInUseResponseModel {
    isInUse;
}
//# sourceMappingURL=tracing-account-is-in-use-response.js.map